import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/api";
import { toast } from "react-toastify";

const initialState = {
    isLoggedIn: false,
    user: {
    },
    errorMsg: "",
    isError: false
}

export const getProfile = createAsyncThunk('getProfile', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getProfile();

        if (status === 200) {
            console.log(data?.data);

            dispatch(setLogin(data?.data));
            dispatch(setAdminData(data?.data))
        }
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const updateAccountSettingsThunk = createAsyncThunk(
    'admin/updateaccount',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateSettings(data);
            toast.success(response.data?.data?.message || 'success')
            dispatch(getProfile())
            return response.status
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message)
        }
    }
);


const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLogin: (state, action) => {
            state.isLoggedIn = true
        },
        setLogout: (state, action) => {
            state.isLoggedIn = false
        },
        setAdminData: (state, action) => {
            state.user = action.payload
        }
    }
})

export const { setLogin, setLogout, setAdminData } = userSlice.actions

export default userSlice.reducer